const Logo = () => {
  const projectName = process.env.REACT_APP_PRJ_NAME?.trim() || 'コースコープ';

  return (
    <div className="logo-image pl-5">
      <div className="text-[20px] font-bold bg-gradient-to-r from-[#00c26f] to-[#0099ff] bg-clip-text text-transparent">
        {projectName}
      </div>
    </div>
  );
};

export default Logo;
